<template>
  <vue-bootstrap-typeahead
    v-model="actionNameFragment"
    :data="suggestions"
    :minMatchingChars="1"
  />
</template>

<script>
import VueBootstrapTypeahead from './VueBootstrapTypeahead.vue';

import { getEnumResourceGameActionValues } from '../autogen/bundle';
import { getEnumResourceGameActionName   } from '../autogen/bundle';

export default {
  name: 'ResourceGameActionNameFragmentInput',

  components: {
    VueBootstrapTypeahead,
  },

  props: {
    value: {
      default: '',
    },
  },

  data() {
    return {
      actionNameFragment: this.value,
      actionNames: calcSortedActionNames(),
    };
  },

  computed: {
    suggestions() {
      const MAX_AMOUNT = 7;

      // Для регистронезависимого поиска переводим строки в нижний регистр.
      const actionNameFragmentLowerCase = this.actionNameFragment.toLowerCase();
    
      const suggestions = [];
      for(const actionName of this.actionNames) {
        const actionNameLowerCase = actionName.toLowerCase();
        if(!actionNameLowerCase.includes(actionNameFragmentLowerCase)) {
          continue;
        }
        suggestions.push(actionName);
        if(suggestions.length === MAX_AMOUNT) {
          return suggestions;
        }
      }

      return suggestions;
    },
  },

  watch: {
    actionNameFragment(newActionNameStr) {
      this.$emit('input', newActionNameStr);
    },
  },
};

function calcSortedActionNames() {
  const actionNames = calcActionNames();
  actionNames.sort();
  return actionNames;
}

function calcActionNames() {
  const actionNames = [];

  for(const actionCode of getEnumResourceGameActionValues()) {
    const actionName = getEnumResourceGameActionName(actionCode);
    actionNames.push(actionName);
  }

  return actionNames;
}

</script>
